import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { NOTIFICATION_API_URL } from 'modules/profile/notifications/api/notification-center'
import {
  NotificationSettingEditApiInterface,
  NotificationSettingInterface,
} from 'modules/profile/notifications/types/notification-settings-interface'

export const useNotificationSettingsActions = () => {
  const { fetcher: postFetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.post,
    NotificationSettingInterface
  >({
    method: RequestMethodsEnum.post,
  })

  const updateNotificationSetting = async (data: NotificationSettingEditApiInterface) =>
    await postFetcher(`${NOTIFICATION_API_URL}/subscriptions`, data)

  return {
    updateNotificationSetting,
  }
}
